module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "teacher-bg"
  }, [_c('keep-alive', [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "tab-view"
  }, [_c('router-link', {
    attrs: {
      "to": "/work",
      "active-class": "u-link--Active1"
    }
  }, [_c('div', {
    staticClass: "tab work"
  }, [_vm._v("工 作")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/teacher-info",
      "active-class": "u-link--Active3"
    }
  }, [_c('div', {
    staticClass: "tab my"
  }, [_vm._v("我 的")])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13e9b783"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/TeacherMain.vue
// module id = 759
// module chunks = 1